import React from 'react';
import { I18nextProvider } from 'react-i18next';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import webFont from 'webfontloader';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.scss';
import UserLeaveConfirmation from './Routing/UserLeaveConfirmation';
import i18n from './i18n';
import store from './_enchancers/configureStore';
import { configureFakeBackend } from './_services/configureFakeBackend';
import history from './_enchancers/history';

webFont.load({
  custom: {
    families: ['Lato', 'sans-serif'],
    urls: ['/fonts/Lato/lato.css'],
  },
});

configureFakeBackend();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter
      history={history}
      getUserConfirmation={(message, callback) => UserLeaveConfirmation(message, callback)}
    >
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </React.StrictMode>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
